import React, { useState} from "react";
import parse from "html-react-parser";
import foods from "../data/foods.json";
import ReactCountryFlag from "react-country-flag";
import countryCodes from "../data/countryCodes.json";
import countryContinents from "../data/countryContinents.json";

import {
  ComposableMap,
  Geographies,
  Geography
} from "react-simple-maps";


function stringToColor(str) {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }

  // Golden angle distributes colors more evenly
  const hue = (Math.abs(hash) * 137.508) % 360;

  // Vary saturation/lightness too
  const saturation = 60 + (Math.abs(hash >> 8) % 25);
  const lightness = 45 + (Math.abs(hash >> 16) % 20);

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

function getContinentView(selectedRegion) {
  const views = {
    World: {
      center: [0, 20],
      scale: 150
    },

    Asia: {
      center: [100, 34],
      scale: 400
    },

    Europe: {
      center: [9, 54],
      scale: 650
    },

    Africa: {
      center: [10, 1],
      scale: 450
    },

    "North America": {
      center: [-100, 48],
      scale: 400
    },

    "South America": {
      center: [-60, -17],
      scale: 550
    },

    Oceania: {
      center: [135, -25],
      scale: 700
    }
  };

  return (
    views[selectedRegion] ||
    views.World
  );
}


export default function Home() {

  const isMobile =
  typeof window !== "undefined" &&
  window.innerWidth < 768;

  const [selectedCountry, setSelectedCountry] =
    useState(null);

  const [showPopup, setShowPopup] =
    useState(false);

  const [selectedRegion, setSelectedRegion] =
    useState("World");

  const cookedCountries =
    new Set(
      foods.map(
        food => food.country
      )
    );

  const countryColors = {};

  [...cookedCountries].forEach(
    country => {
      countryColors[country] =
        stringToColor(country);
    }
  );

  const selectedFoods = foods.filter(
    food => food.country === selectedCountry
  );

  const filteredFoods =
  selectedRegion === "World"
    ? foods
    : foods.filter(
        food =>
          countryContinents[
            food.country
          ] === selectedRegion
      );


  const recipeCount = filteredFoods.length;

  const countryCount =
    new Set(
      filteredFoods.map(
        food => food.country
      )
    ).size;
  
const mapView =
  getContinentView(
    selectedRegion
  );

  return (
    <div>
      <h1>Foods Around the World</h1>

      <p
  style={{
    maxWidth: "900px",
    width: "90%",
    lineHeight: "1.8",
    fontSize: "clamp(0.95rem, 2vw, 1.05rem)",
    color: "#444",
    textAlign: "left",
  }}
>
This started as an experimental fun project around mid 2025, where I would randomly pick a country and make food from that country as my weekly meal prep. 
The exercise has led me to cook and eat more diverse food and experience flavor profiles that I did not grow up with. It has been lovely learning about 
new food ingredients, cooking styles, food histories, and noticing similarities and differences across geographies.<br/><br/>
The website is still work-in-progress. Right now, you can filter only by the continent. If you click on the color-coded countries you will get to see the food 
I have cooked from that country along with a short description. 
</p>

    <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "20px",
    flexWrap: "wrap"
  }}
>
  <div>
    <label
      style={{
        marginRight: "10px",
        fontWeight: "bold",
         marginLeft: "10px",
      }}
    >
      View:
    </label>

    <select
      value={selectedRegion}
      onChange={(e) =>
        setSelectedRegion(
          e.target.value
        )
      }
      style={{
        padding: "6px 10px"
      }}
    >
      <option value="World">
        Whole World
      </option>

      <option value="Africa">
        Africa
      </option>

      <option value="Asia">
        Asia
      </option>

      <option value="Europe">
        Europe
      </option>

      <option value="North America">
        North America
      </option>

      <option value="South America">
        South America
      </option>

      <option value="Oceania">
        Oceania
      </option>
    </select>
  </div>

  <div
    style={{
      padding: "6px 12px",
      background: "#f5f5f5",
      borderRadius: "8px",
      border: "1px solid #ddd",
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
      alignItems: "center"
    }}
  >
    🍽️ Recipes: {recipeCount}
  </div>

  <div
    style={{
      padding: "6px 12px",
      background: "#f5f5f5",
      borderRadius: "8px",
      border: "1px solid #ddd",
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
      alignItems: "center"
    }}
  >
    🌍 Countries: {countryCount}
  </div>
</div>

  <ComposableMap
    width={1000}
    height={600}
    style={{
      width: "100%",
      height: "auto"
    }}
    projection="geoMercator"
    projectionConfig={{
    center: mapView.center,
    scale: mapView.scale
  }}
  >

  <Geographies geography="/maps/world.geojson">
          {({ geographies }) =>
            geographies.map(geo => {
              const countryName =
                geo.properties.ADMIN ||
                geo.properties.NAME ||
                geo.properties.name;

              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={
                    countryColors[countryName] ||
                    "#E0E0E0"
                  }
                  stroke={
                    countryColors[countryName]
                      ? "#000000"
                      : "#CCCCCC"
                  }

                  strokeWidth={
                    countryColors[countryName]
                      ? 0.3
                      : 0
                  }
                  style={{
                    default: {
                      outline: "none"
                    }
                  }}
                  onClick={() => {
                    if (
                      cookedCountries.has(countryName)
                    ) {
                      setSelectedCountry(
                        countryName
                      );
                      setShowPopup(true);
                    }
                  }}
                />
              );
            })
          }
        </Geographies>
  </ComposableMap>

      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
          onClick={() =>
            setShowPopup(false)
          }
        >
          <div
            style={{
              background: "white",
              width: "90%",
              maxWidth: "800px",
              maxHeight: "80vh",
              overflowY: "auto",
              borderRadius: "10px",
              padding: "20px"
            }}
            onClick={e =>
              e.stopPropagation()
            }
          >
          <div style={{ marginBottom: "20px" }}>
            <h2 style={{ margin: 0 }}>
              {selectedCountry}
            </h2>

            {countryCodes[selectedCountry] && (
              <ReactCountryFlag
                countryCode={countryCodes[selectedCountry]}
                svg
                style={{
                  width: "40px",
                  height: "30px",
                  marginTop: "8px"
                }}
              />
            )}
          </div>

            <button
              onClick={() =>
                setShowPopup(false)
              }
            >
              Close
            </button>

            {selectedFoods.map(food => (
              <div
                key={food.id}
                style={{
                  border: "1px solid #ddd",
                  padding: "15px",
                  marginTop: "15px",
                  borderRadius: "8px",
                  display: "flex",
                  gap: "20px",
                  alignItems: "flex-start"
                }}
              >
              <div
                style={{
                  display: "flex",
                  flexDirection:
                    isMobile
                      ? "column"
                      : "row",
                  gap: "20px"
                }}
              >
                <img
                  src={food.image}
                  alt={food.foodName}
                  style={{
                    width: "50%",
                    maxWidth: "200px",
                    borderRadius: "8px",
                    border: "1px solid black",
                    objectFit: "cover"
                  }}
                />

                <div style={{ flex: 1 }}>
                  <h3>{food.foodName}</h3>
              
                    <div>
                      {parse(food.description)}
                    </div>
                </div>
              </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export const Head = () => (
  <>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1"
    />
    <title>
      Foods Around the World
    </title>
  </>
);